export default {
  children: [
    {
      path: "",
      name: "guia-search",
      component: () => import("@/modules/guia/components/GuiaSearch.vue"),
       meta: { countViews: true }
    },
    {
      path: "descargar",
      name: "guia-download",
      component: () => import("@/modules/guia/components/GuiaDownload.vue"),
       meta: { countViews: true }
    },
  ],
};
